import { useNavigate } from "react-router-dom";
import RegisterCustomerModal from "../components/RegisterCustomerModal";

const Register = () => {
  const navigate = useNavigate();

  return (
    <RegisterCustomerModal
      onClose={() => navigate("/")}
      onLoginClick={() => navigate("/login")}
    />
  );
};

export default Register;
